const mergePermission = (current, incoming) => {
  if (current === true || incoming === true) return true
  if (current === false || incoming === false) return false
  return current ?? incoming ?? null
}

export const normalizeScreen = (screen = {}) => {
  const normalized = {
    read: screen.read ?? null,
    create: screen.create ?? null,
    delete: screen.delete ?? null,
    update: screen.update ?? null,
    screen_id: screen.screen_id,
    screen_route: screen.screen_route,
    screen_namear: screen.screen_namear,
    screen_nameen: screen.screen_nameen,
  }

  if (screen.is_default_screen != null) {
    normalized.is_default_screen = screen.is_default_screen
  }

  if (screen.is_form != null) {
    normalized.is_form = Boolean(screen.is_form)
  }

  if (screen.parent_id != null && screen.parent_id !== '') {
    normalized.parent_id = screen.parent_id
  }

  if (screen.visable != null) {
    normalized.visable = Boolean(screen.visable)
  } else if (screen.visible != null) {
    normalized.visable = Boolean(screen.visible)
  }

  return normalized
}

const mergeScreens = (existing, incoming) => ({
  ...existing,
  read: mergePermission(existing.read, incoming.read),
  create: mergePermission(existing.create, incoming.create),
  update: mergePermission(existing.update, incoming.update),
  delete: mergePermission(existing.delete, incoming.delete),
  is_form: incoming.is_form ?? existing.is_form,
  parent_id: incoming.parent_id ?? existing.parent_id,
})

const dedupeScreensById = (screens = []) => {
  const screenMap = new Map()

  screens.forEach((screen) => {
    const key = screen?.screen_id ?? screen?.screen_route
    if (key == null) return

    const normalized = normalizeScreen(screen)
    const existing = screenMap.get(key)
    screenMap.set(key, existing ? mergeScreens(existing, normalized) : normalized)
  })

  return Array.from(screenMap.values())
}

export const normalizeScreenGroups = (screens) => {
  if (!Array.isArray(screens) || screens.length === 0) return []

  const isGrouped = Boolean(screens[0]?.screens) && !screens[0]?.screen_route

  if (!isGrouped) {
    return [
      {
        group_id: 0,
        group_name_ar: 'القائمة',
        screens: dedupeScreensById(screens),
      },
    ]
  }

  const groupMap = new Map()

  screens.forEach((group) => {
    const key = group.group_id ?? group.group_name_ar ?? group.group_name_en
    const existing = groupMap.get(key)

    if (existing) {
      existing.screens.push(...(group.screens || []))
      return
    }

    groupMap.set(key, {
      ...group,
      screens: [...(group.screens || [])],
    })
  })

  return Array.from(groupMap.values()).map((group) => ({
    ...group,
    screens: dedupeScreensById(group.screens),
  }))
}

export const flattenScreens = (screens) =>
  normalizeScreenGroups(screens).flatMap((group) => group.screens || [])

export const findScreenByRoute = (screens, route) =>
  flattenScreens(screens).find((screen) => screen.screen_route === route) ?? null
